<template>
<body>
  <!-- 公告栏 -->
  <!-- <van-overlay :show="show" z-index="99999">
    <div class="wrapper" @click.stop>
      <div class="block">
        <h4 style="margin: 30px auto 10px; font-weight: bold;">公告</h4>
        <p
          style="color: rgb(121, 121, 121); font-size: 16px; padding: 5px 10px; line-height: 26px; margin: -3px auto 18px; display: block; width: 85%;"
        >{{messageTie}}</p>
        <van-button
          size="large"
          block
          style="border-radius: 0px 0px 8px 8px; height: 52px; line-height: 52px;"
          @click="show = false,initHeigth()"
        >
          <span>
            <p style="color: rgb(103, 109, 143); font-size: 18px; margin-top: -10px;">
              <b>我知道了</b>
            </p>
          </span>
        </van-button>
      </div>
    </div>
  </van-overlay> -->


  <div class="alertMain">
    <div class="alert">
      <div class="alertHead">
        <el-row :gutter="20" type="flex" justify="space-around">
          <el-col :span="8">
            <div class="grid-content">
              <div class="nav" v-if="ToB==1">
                <div class="tian" :class="{isActive:flag==true}">
                  <p>
                    <b>To B</b>
                  </p>
                </div>
                <div class="pos" :class="{isActive:flag==false}">
                  <p>
                    <b>To C</b>
                  </p>
                </div>
              </div>
              <div class="nav" v-if="ToC==1">
                <div class="tian" :class="{isActive:flag==true}">
                  <p>
                    <b>To B</b>
                  </p>
                </div>
                <div class="pos" :class="{isActive:flag==false}">
                  <p>
                    <b>To C</b>
                  </p>
                </div>
              </div>
              <div class="nav" @click="change" v-if="ToBC==1">
                <div class="tian" :class="{isActive:flag==true}">
                  <p>
                    <b>To B</b>
                  </p>
                </div>
                <div class="pos" :class="{isActive:flag==false}">
                  <p>
                    <b>To C</b>
                  </p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <div class="listSel">
                <van-dropdown-menu active-color="#CC4545" :overlay="false">
                  <van-dropdown-item
                    v-model="value"
                    :options="PlatformList"
                    @change="changePlatform(value)"
                  />
                </van-dropdown-menu>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <div class="listSel2">
                <van-dropdown-menu active-color="#CC4545" :overlay="false">
                  <van-dropdown-item
                    v-model="value2"
                    :options="BrandList"
                    @change="changeBrand(value2)"
                    class="right"
                  />
                </van-dropdown-menu>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="calender2">
        <span class="Message">* 点击日期查看破价详情</span>
        <div class="date-header">
          <div class="pre-month" @click="handlePrev" v-if="heightFlag==false"></div>
          <div class="show-date">
            <b>{{ year }}年{{ month }}月{{ day }}日</b>
          </div>
          <div class="next-month" @click="handleNext" v-if="heightFlag==false"></div>
        </div>
        <div class="date-content">
          <div class="week-header">
            <div v-for="item in weekList" :key="item">{{ item }}</div>
          </div>
          <div class="week-day" v-if="MtoW=='M'">
            <div class="every-day" v-for="item in 42" :key="item">
              <div
                @click="handleClickDay(item - beginDay())"
                :class="[{NowDay:`${year}-${month}-${item - beginDay()}` == curDate},{activeDay:`${year}-${month.toString().padStart(2,0)}-${(item - beginDay()).toString().padStart(2,0)}` === `${dataFromYes}`}]"
                v-if="item - beginDay() > 0 && item - beginDay() <= curDays()"
              >
                <span
                  style="opacity:0;display:none"
                >{{`${year}-${month.toString().padStart(2,0)}-${(item - beginDay()).toString().padStart(2,0)}`}}</span>
                <b>{{ item - beginDay() }}</b>
              </div>
              <div
                class="other-day"
                v-else-if="item - beginDay() <= 0"
              >{{ item - beginDay() + curDays() }}</div>
              <div class="other-day" v-else>{{ item - beginDay() -curDays() }}</div>
            </div>
          </div>
        </div>
        <div class="week-day" v-if="MtoW=='W'">
          <div class="every-day" v-for="(item,i) in dayList" :key="i">
            <div
              @click="handleWeek(item.day)"
              :class="[{NowDay:`${item.year}-${item.month}-${item.day}` == curDate},{activeDay:`${item.year}-${item.month.toString().padStart(2,0)}-${item.day.toString().padStart(2,0)}` === `${year}-${month.toString().padStart(2,0)}-${day.toString().padStart(2,0)}`}]"
              v-if="Date.parse(item.all)>=Date.parse(weekStart)&&Date.parse(item.all)<=Date.parse(weekEnd)"
            >
              <span
                style="opacity:0;display:none"
              >{{`${item.year}-${item.month.toString().padStart(2,0)}-${item.day.toString().padStart(2,0)}`}}</span>
              <b>{{ item.day }}</b>
            </div>
            <div class="other-day" v-else>{{ item.day }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="alertFoot">
      <img
        src="../../assets/jpg/showBtn.png"
        @click="changeindustryMsg()"
        style="position: absolute;left: 10%;width:20px;height:20px;"
        alt
      />
      <div v-show="industryMsgFlag" class="industryMsg" v-html="industryMsg"></div>
      <h3 class="el-icon-caret-top" @click="showTable()" v-if="heightFlag">
        <b>查看日历</b>
        <p>请点击查看日历浏览历史信息</p>
      </h3>
      <h3 class="el-icon-caret-bottom" @click="showTable()" v-else>
        <b>查看详情</b>
      </h3>
      <div class="tableHead" v-if="totalListFlag">
        <el-row :gutter="20" v-for="(item,i) in abnormalList" :key="i">
          <el-col :span="8">
            <div class="headerTit" v-if="value=='PDD'">
              <span>异常记录数：</span>
              <b>{{item.total|NumFormat}}</b>
            </div>
             <div class="headerTit" v-else>
              <span>异常总数：</span>
              <b>{{item.total|NumFormat}}</b>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="headerTit" v-show="value!='PDD'">
              <span>异常总额：</span>
              <b>{{item.totalAmount|NumFormat}}</b>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="opacity:0">1</div>
          </el-col>
        </el-row>
      </div>
      <div class="tableTitle" v-if="value=='EC'">
        <el-row>
          <el-col :span="3">
            <div class="grid-content bg-purple">渠道</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">供应商</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">SKU</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">交易价</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">指导价</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple">数量</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">总额</div>
          </el-col>
        </el-row>
      </div>
      <div class="tableTitle" v-else-if="value=='NDC'">
        <el-row>
          <el-col :span="2">
            <div class="grid-content bg-purple">渠道</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple">区域</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">分销商</div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple">SKU</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">交易价</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">指导价</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple">数量</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple">总额</div>
          </el-col>
        </el-row>
      </div>
      <div class="tableTitle" v-else-if="value=='NKA/LKA'">
        <el-row>
          <!-- <el-col :span="3">
            <div class="grid-content bg-purple">渠道</div>
          </el-col>-->
          <el-col :span="3">
            <div class="grid-content bg-purple">客户</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">店铺</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">SKU</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">交易价</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">指导价</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple">数量</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">总额</div>
          </el-col>
        </el-row>
      </div>
      <div class="tableTitle" v-else-if="value=='Tmall'||value=='JD'">
        <el-row>
          <el-col :span="3">
            <div class="grid-content bg-purple">渠道</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">店铺</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">SKU</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">交易价</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">指导价</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple">数量</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">总额</div>
          </el-col>
        </el-row>
      </div>
        <div class="tableTitle" v-else-if="value=='PDD'">
        <el-row>
          <el-col :span="3">
            <div class="grid-content bg-purple">渠道</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">店铺</div>
          </el-col>
          <el-col :span="7">
            <div class="grid-content bg-purple">SKU</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">交易价</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">指导价</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">产品链接</div>
          </el-col>
        </el-row>
      </div>
      <div class="tableContent" v-if="totalListFlag">
        <div class="tableList" style="margin-bottom:80px" v-if="value=='EC'">
          <el-row v-for="(item,i) in totalList" :key="i" style="margin-top:10px">
            <el-col :span="3">
              <div class="grid-content">{{item.channel}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.shopName}}</div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" style="color:rgb(107,102,149)">{{item.skuName}}</div>
            </el-col>
            <el-col :span="3">
              <div :class="item.flag=='1'?'grid-content lowColor':'grid-content'">{{item.price}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.guidPrice}}</div>
            </el-col>
            <el-col :span="2">
              <div
                class="grid-content"
                :class="item.flag=='0'?'grid-content lowColor':'grid-content'"
              >{{item.num}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.totalAmount}}</div>
            </el-col>
          </el-row>
        </div>
        <div class="tableList" style="margin-bottom:80px" v-if="value=='NDC'">
          <el-row v-for="(item,i) in totalList" :key="i" style="margin-top:10px">
            <el-col :span="2">
              <div class="grid-content">{{item.channel}}</div>
            </el-col>
            <el-col :span="2">
              <div class="grid-content">{{item.bigArea}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content" style="color:rgb(107,102,149)">{{item.shopName}}</div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content" style="color:rgb(107,102,149)">{{item.skuName}}</div>
            </el-col>
            <el-col :span="3">
              <div :class="item.flag=='1'?'grid-content lowColor':'grid-content'">{{item.price}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.guidPrice}}</div>
            </el-col>
            <el-col :span="2">
              <div
                class="grid-content"
                :class="item.flag=='0'?'grid-content lowColor':'grid-content'"
              >{{item.num}}</div>
            </el-col>
            <el-col :span="2">
              <div class="grid-content">{{item.totalAmount}}</div>
            </el-col>
          </el-row>
        </div>
        <div class="tableList" style="margin-bottom:80px" v-if="value=='NKA/LKA'">
          <el-row v-for="(item,i) in totalList" :key="i" style="margin-top:10px">
            <!-- <el-col :span="3">
              <div class="grid-content">{{item.channel}}</div>
            </el-col>-->
            <el-col :span="3">
              <div class="grid-content">{{item.ka}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.shopName}}</div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" style="color:rgb(107,102,149)">{{item.skuName}}</div>
            </el-col>
            <el-col :span="3">
              <div :class="item.flag=='1'?'grid-content lowColor':'grid-content'">{{item.price}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.guidPrice}}</div>
            </el-col>
            <el-col :span="2">
              <div
                class="grid-content"
                :class="item.flag=='0'?'grid-content lowColor':'grid-content'"
              >{{item.num}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.totalAmount}}</div>
            </el-col>
          </el-row>
        </div>
        <div class="tableList" style="margin-bottom:80px" v-if="value=='Tmall'||value=='JD'">
          <el-row v-for="(item,i) in totalList" :key="i" style="margin-top:10px">
            <el-col :span="3">
              <div class="grid-content">{{item.channel}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.shopName}}</div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" style="color:rgb(107,102,149)">{{item.skuName}}</div>
            </el-col>
            <el-col :span="3">
              <div :class="item.flag=='1'?'grid-content lowColor':'grid-content'">{{item.price}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.guidPrice}}</div>
            </el-col>
            <el-col :span="2">
              <div
                class="grid-content"
                :class="item.flag=='0'?'grid-content lowColor':'grid-content'"
              >{{item.num}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.totalAmount}}</div>
            </el-col>
          </el-row>
        </div>
         <div class="tableList" style="margin-bottom:80px" v-if="value=='PDD'">
          <el-row v-for="(item,i) in totalList" :key="i" style="margin-top:10px">
            <el-col :span="3">
              <div class="grid-content">{{item.channel}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.shopName}}</div>
            </el-col>
            <el-col :span="7">
              <div class="grid-content" style="color:rgb(107,102,149)">{{item.skuName}}</div>
            </el-col>
            <el-col :span="3">
              <div :class="item.flag=='1'?'grid-content lowColor':'grid-content'">{{item.price}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.guidPrice}}</div>
            </el-col>
            <el-col :span="4">
              <div  class="grid-content"><a :href='item.productLine' style="color:#2440b3">产品链接</a></div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-else class="tableContent kong">
        <h3 style="color:#ccc">该日无异常</h3>
      </div>
    </div>
  </div>
</body>
</template>
<script>
import qs from "qs";
import { Toast } from "vant";

export default {
  data() {
    return {
      messageTie: "国庆期间暂停更新，敬请谅解",
      show: false,
      industryMsg: `报告说明：当交易价格低于目标价格时，此笔交易将会显示在报告中。NKA/LKA渠道中，当该店铺销量超过所属KA所有店铺平均销量6倍时，亦会显示在报告中。
</br>更新时间：每日11点更新前日数据。</br>SKU说明：现仅监测17个(To-B)以及15个(To-C)SKU`,
      industryMsgFlag: false,
      initFlag: false,
      wwid: "",
      heightFlag: true,
      totalListFlag: false,
      flag: "",
      ToB: 0,
      ToC: 0,
      ToBC: 0,
      year: null,
      month: null,
      day: null,
      curDate: "",
      dataFrom: "",
      dataFromYes: "",
      totalNumList: [],
      totalList: [],
      abnormalList: [],
      value: "",
      value2: "",
      PlatformList: [],
      BrandList: [],
      MtoW: "M",
      weekList: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayList: [],
      weekEnd: "",
      weekStart: "",
      offsetHeight: "",
    };
  },
  methods:{
     getMsgNotice(){
       this.$addr
        .post("Log/getNotice",qs.stringify({menuId:'5'})).then((res)=>{
            if(res.data.data.isEffective==1){
            this.show=true
          this.messageTie=res.data.data.notice

          }else{
             this.show=false
          }
        })
    },
  },
  created() {
    // this.getMsgNotice()
    this.initHeigth();
    this.getUserInfo();
    this.getInitDate();
    this.geToBc();
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.value = newVal;
        this.getDayTotal();
        this.getDayTableList();
      },
    },
  },
  methods: {
    changeindustryMsg() {
      this.industryMsgFlag = !this.industryMsgFlag;
    },
    initHeigth() {
      this.$nextTick(() => {
        $(window).ready(() => {
          this.offsetHeight ==
            parseInt(
              $(document).height() -
                ($(".activeDay").offset().top +
                  $(".activeDay").outerHeight(true))
            );
          $(".alertFoot").css(
            "height",
            parseInt(
              $(document).height() -
                ($(".activeDay").offset().top +
                  $(".activeDay").outerHeight(true))
            )
          );
        });
      });
    },
    handleWeek(day) {
      this.day = day;
      this.dataFromYes = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-${day.toString().padStart(2, 0)}`;
      this.weekStart = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-01`;
      this.weekEnd = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-${this.curDays()}`;
      this.getDayTotal();
      this.getDayTableList();
    },
    getUserInfo() {
      if (sessionStorage.userInfo != undefined) {
        const user = JSON.parse(sessionStorage.userInfo);
        this.name = user.name;
        this.wwid = user.wwid;
      } else {
        this.$router.push({ path: "/" });
      }
    },
    getDayTotal() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.$addr
        .post(
          "priceAlert/getDailyTotal",
          qs.stringify({
            wwId: this.wwid,
            channel: this.value,
            brand: this.value2,
            type: this.flag ? "0" : "1",
            dateFrom: this.dataFrom,
            dateTo: this.dataTo,
          })
        )
        .then((res) => {
          this.totalNumList = [];
          this.totalNumList = res.data.data;
          var arr = $(".every-day").children("div").children("span");
          let arrList = [...arr];
          arrList.map((item) => {
            if (
              Date.parse($(item).text().trim()) <= Date.parse(this.dataBegin) &&
              Date.parse($(item).text().trim()) > Date.parse("2020-07-31")
            ) {
              var text2 = `<p style='position: absolute;
                              width: 70%;
                              bottom: 5px;
                              border-radius: 15px;
                              background-color: rgb(33, 163, 102);
                              height: 15px;
                              line-height: 15px;
                              left: 13%;'>${0}</p>`;
              $(item).next("b").append(text2);
            }
            if (this.totalNumList.length > 0) {
              this.totalNumList.map((item2) => {
                if (item2.date.trim() == $(item).text().trim()) {
                  var text1 = `<p style='position: absolute;
                              width: 70%;
                              bottom: 5px;
                              border-radius: 15px;
                              background-color: rgb(203, 79, 79);
                              height: 15px;
                              line-height: 15px;
                              left: 13%;'>${item2.total}</p>`;
                  $(item).next("b").append(text1);
                }
              });
            }
          });
          Toast.clear();
        })
        .catch((error) => {});
    },
    getDayTableList() {
      this.$addr
        .post(
          "priceAlert/getDailyList",
          qs.stringify({
            wwId: this.wwid,
            channel: this.value,
            brand: this.value2,
            type: this.flag ? "0" : "1",
            dateFrom: this.dataFromYes,
            dateTo: this.dataFromYes,
          })
        )
        .then((res) => {
          if (res.data.data.length >= 1) {
            this.totalListFlag = true;
            this.totalList = res.data.data;
            this.abnormalList = res.data.total;
          } else {
            this.totalListFlag = false;
          }
        })
        .catch((error) => {});
    },
    geToBc() {
      this.$addr
        .post("priceAlert/getToBC", qs.stringify({ wwId: this.wwid }))
        .then((res) => {
          if (res.data.data.length <= 1) {
            if (res.data.data[0].tobcType == "0") {
              this.flag = true;
              this.ToB = 1;
              this.ToC = 0;
              this.toBC = 0;
            } else if (res.data.data[0].tobcType == "1") {
              this.flag = false;
              this.ToC = 1;
              this.toBC = 0;
              this.toB = 0;
            }
          } else {
            this.ToBC = 1;
            this.ToB = 0;
            this.ToC = 0;
          }
          this.$nextTick(()=>{
            // console.log(this.flag);
          })
          this.getChannelList();
        })
        .catch((error) => {});
    },
    getChannelList() {
      this.$addr
        .post(
          "priceAlert/getChannel",
          qs.stringify({
            wwId: this.wwid,
            brand: "",
            type: this.flag ? "0" : "1",
          })
        )
        .then((res) => {
          this.PlatformList = [];
          res.data.data.map((item) => {
            this.PlatformList.push({
              text: item.channel,
              value: item.channel,
            });
          });
          this.value = res.data.data[res.data.data.length - 1].channel;
          this.getBrandList();
        })
        .catch((error) => {});
    },
    getBrandList() {
      this.value2 = "";
      this.$addr
        .post(
          "priceAlert/getBrand",
          qs.stringify({
            wwId: this.wwid,
            channel: this.value,
            type: this.flag ? "0" : "1",
          })
        )
        .then((res) => {
          this.BrandList = [{ text: "全部品牌", value: "" }];
          res.data.data.map((item) => {
            this.BrandList.push({
              text: item.brand,
              value: item.brand,
            });
          });
        })
        .catch((error) => {});
    },
    showTable() {
      if (this.heightFlag) {
        $(".alertFoot").animate({ height: "100px" });
        this.MtoW = "M";
        $(".every-day")
          .children("div")
          .children("span")
          .next("b")
          .children("p")
          .remove();
        this.heightFlag = false;
      } else {
        $(".alertFoot").animate({ height: $(document).height() * 0.65 });
        this.heightFlag = true;
      }
      this.getDayTotal();
    },
    changePlatform() {
      this.getBrandList();
      $(".every-day")
        .children("div")
        .children("span")
        .next("b")
        .children("p")
        .remove();
      this.getDayTotal();
      this.getDayTableList();
    },
    changeBrand() {
      $(".every-day")
        .children("div")
        .children("span")
        .next("b")
        .children("p")
        .remove();
      this.getDayTotal();
      this.getDayTableList();
    },
    change() {
      this.flag = !this.flag;
      this.value = "";
      this.value2 = "";
      $(".every-day")
        .children("div")
        .children("span")
        .next("b")
        .children("p")
        .remove();
      this.getBrandList();
      this.getChannelList();
      this.getDayTotal();
      this.getDayTableList();
    },
    handleClickDay(day) {
      this.MtoW = "W";
      this.getDayTotal();
      this.showTable();
      this.day = day;
      this.dataFromYes = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-${day.toString().padStart(2, 0)}`;

      this.weekStart = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-01`;

      this.weekEnd = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-${this.curDays()}`;
      var week = new Date(this.dataFromYes).getDay();
      var days = [];
      days.length = 0;
      for (let i = week; i >= 0; i -= 1) {
        const d = new Date(this.dataFromYes);
        d.setDate(d.getDate() - i);
        days.push(d);
      }
      for (let i = 1; i <= 6 - week; i += 1) {
        const d = new Date(this.dataFromYes);
        d.setDate(d.getDate() + i);
        days.push(d);
      }
      this.dayList = [];
      days.map((item) => {
        this.dayList.push({
          year: item.getFullYear(),
          month: item.getMonth() + 1,
          day: item.getDate(),
          all: `${item.getFullYear()}-${(item.getMonth() + 1)
            .toString()
            .padStart(2, 0)}-${item.getDate().toString().padStart(2, 0)}`,
        });
      });
      this.getDayTableList();
    },
    computedDay() {
      $(".every-day")
        .children("div")
        .children("span")
        .next("b")
        .children("p")
        .remove();
      const allDay = new Date(this.year, this.month, 0).getDate();
      if (this.day > allDay) {
        this.day = allDay;
      }
      this.dataFrom = `${this.year}-${this.month.toString().padStart(2, 0)}-01`;
      this.dataTo = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-${allDay.toString().padStart(2, 0)}`;
      this.getDayTotal();
    },
    handlePrev() {
      if (this.month == 1) {
        this.month = 12;
        this.year--;
      } else {
        this.month--;
      }

      this.computedDay();
    },
    handleNext() {
      if (this.month == 12) {
        this.month = 1;
        this.year++;
      } else {
        this.month++;
      }
      this.computedDay();
    },
    getInitDate() {
      const date = new Date();
      this.year = date.getFullYear();
      this.month = date.getMonth() + 1;
      this.day = date.getDate();
      this.dataBegin = `${this.year}-${this.month
        .toString()
        .padStart(2, 0)}-${(this.day-1).toString().padStart(2, 0)}`;
      this.curDate = `${this.year}-${this.month}-${this.day}`;
      if (this.day - 1 == 0) {
        this.month--;
        const allDay2 = new Date(this.year, this.month, 0).getDate();

        this.dataFromYes = `${this.year}-${this.month
          .toString()
          .padStart(2, 0)}-${allDay2.toString().padStart(2, 0)}`;
      } else {
        this.dataFromYes = `${this.year}-${this.month
          .toString()
          .padStart(2, 0)}-${(this.day - 1).toString().padStart(2, 0)}`;
      }
      this.computedDay();
    },
    beginDay() {
      return new Date(this.year, this.month - 1, 1).getDay();
    },
    curDays() {
      return new Date(this.year, this.month, 0).getDate();
    },
  },
  beforeRouteLeave(to, from, next) {
    var time = new Date();
    var y = time.getFullYear();
    var m = (time.getMonth() + 1).toString().padStart(2, "0");
    var d = time.getDate().toString().padStart(2, "0");
    var h = time.getHours().toString().padStart(2, "0");
    var mm = time.getMinutes().toString().padStart(2, "0");
    var s = time.getSeconds().toString().padStart(2, "0");
    var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
    const sendEndObj = {
      startDate: "",
      endDate: EndTime,
      wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
      name: JSON.parse(sessionStorage.getItem("userInfo")).name,
      menu: "Price Alert",
    };
    this.$addr.post("Log/insert", qs.stringify(sendEndObj)).then((res) => {
      next();
    });
  },
};
</script>
<style scoped>
.block {
  width: 350px;
  min-height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.industryMsg {
  text-align: left;
  z-index: 999;
  position: absolute;
  width: 75%;
  min-height: 50px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  font-family: "SourceHanSansCN-Medium";
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  left: 18%;
  padding: 10px;
  top: 20px;
}
.kong {
  background: url("../../assets/jpg/空状态.png") center no-repeat;
}
.lowColor {
  color: #cc4545;
}
.dateNum {
  position: absolute;
  width: 100%;
  bottom: -10px;
  border-radius: 15px;
  background-color: rgb(203, 79, 79);
  height: 15px;
  line-height: 15px;
  left: 0;
}
.bg-purple {
  background: rgb(237, 236, 245);
}
.tableContent {
  position: relative;
  overflow: hidden;
  padding: 10px;
  height: 100%;
  overflow-y: scroll;
}
.tableTitle {
  margin: 20px 0 20px;
}
.tableHead {
  padding: 20px 10px 0px;
}
.tableHead .headerTit {
  background: url("../../assets/jpg/底色.png") no-repeat left bottom;
  background-size: auto 12px;
  display: flex;
  align-items: center;
}
.tableHead .headerTit b {
  font-size: 17px;
  color: #cc4545;
}
body {
  width: 100%;
  height: 100%;
  background: rgb(107, 102, 149);
  overflow: hidden;
}
.nav {
  height: 40px;
  margin: 0 auto;
  background-color: rgb(130, 124, 173);
  border-radius: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav .isActive {
  background: #ffffff;
  border-radius: 30px;
  color: rgb(107, 102, 149) !important;
}
.nav .tian,
.nav .pos {
  height: 40px;
  line-height: 40px;
  width: 50%;
  font-family: "PingFangSC-Medium";
  text-align: center;
  color: #ffffff;
}
.alertMain {
  height: 100%;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.alert {
  padding: 20px 10px;
}
.alertHead {
  height: 60px;
  width: 100%;
  overflow: hidden;
  text-align: center;
}
.alertFoot {
  box-sizing: border-box;
  padding: 20px 0px;
  text-align: center;
  position: absolute;
  bottom: 0;
  background: rgb(244, 246, 250);
  width: 100%;
  border-radius: 30px 30px 0 0;
  overflow: hidden;
  z-index: 5;
}
.alertFoot h3 {
  font-size: 18px;
  line-height: 30px;
  color: rgb(107, 102, 149);
}
.alertFoot h3 p {
  font-size: 14px;
}
* {
  margin: 0px;
  border: 0px;
  list-style: none;
}
.calender2 {
  position: relative;
  min-height: 700px;
}
.Message {
  position: absolute;
  bottom: 23%;
  right: 30px;
  color: #ccc;
  font-size: 14px;
  z-index: 2;
}
.date-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 100%;
  line-height: 40px;
  text-align: center;
}
.pre-month {
  display: inline-block;
  height: 0px;
  width: 0px;
  border: 20px solid;
  border-color: transparent #ccc transparent transparent;
}
.next-month {
  display: inline-block;
  height: 0px;
  width: 0px;
  border: 20px solid;
  border-color: transparent transparent transparent #ccc;
}
.show-date {
  margin-top: 0px;
  display: inline-block;
  line-height: 40px;
  text-align: center;
  width: 310px;
  color: #ffffff;
  font-size: 23px;
}
.week-header {
  margin-top: 10px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
}
.week-day {
  padding: 0 10px;
}
.week-header div {
  margin: 0;
  padding: 0;
  display: inline-block;
  height: 20px;
  width: 60px;
}
.every-day {
  display: inline-block;
  height: 90px;
  width: 60px;
  text-align: center;
  line-height: 75px;
  color: #fff;
  font-style: 18px;
  position: relative;
}

.every-day b div {
  position: absolute;
  display: block;
  width: 10px;
  height: 10px;
  line-height: 10px;
  padding: 5px;
  border-radius: 50%;
  bottom: 0;
  color: #ccc;
  background: red;
}
.other-day {
  color: #ccc;
}

.NowDay::before {
  content: "";
  position: absolute;
  top: 10px;
  width: 10px;
  height: 10px;
  background: #fff !important;
  border-radius: 50%;
}
.activeDay {
  background-color: rgba(88, 83, 130, 0.6);
  border-radius: 15px;
  padding: 0px 0px 20px;
  /* border-sizing:content-box; */
}
.listSel2,
.listSel {
  width: 100%;
  display: flex;
  align-items: center;
  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  line-height: 14px;
}
.listSel2 .van-dropdown-menu {
  z-index: 7;
  border-radius: 30px;
  width: 100%;
  height: 40px;
}

.listSel .van-dropdown-menu {
  z-index: 7;
  border-radius: 30px;
  width: 100%;
  height: 40px;
}
.listSel .van-dropdown-menu /deep/ .van-popup--top {
  width: 28%;
  background: rgba(130, 102, 149, 1);
  border-radius: 5%;
  top: 2px;
  left: 35.5% !important;
}

.listSel2 .van-dropdown-menu /deep/ .van-popup--top {
  width: 28%;
  background: rgb(130, 102, 149, 1);
  border-radius: 5%;
  top: 2px;
  left: 69.5% !important;
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  text-align: center;
  font-family: "PingFangSC-Regular";
  font-size: 14px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: rgb(107, 102, 149);
}
/deep/ .van-dropdown-menu__title::after {
  text-align: right;
  border-color: transparent transparent #555555 #555555;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}

/deep/ .van-hairline--top-bottom::after{
  border: none !important;
}
/deep/ .van-dropdown-menu__bar{
  height: 40px;
  border-radius: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFiv_priceAlert/AlertIndex.vue